var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    fill: "#3751fe",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5,200c-2.1,0-4.3-0.7-6.4-1.4c-5-2.1-7.8-7.1-7.8-12.8V14.3c0-5,2.8-9.9,7.8-12.8c5-2.1,9.9-2.1,14.9,0.7L172.3,88 c4.3,2.8,6.4,7.1,6.4,12.1c0,5-2.1,9.2-6.4,12.1l-129,85.8C41.2,199.3,38.3,200,35.5,200z M49.7,41.2v118.4L139,100 C139,100,49.7,41.2,49.7,41.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlay);
export default __webpack_public_path__ + "static/media/ico-play.23e65ccffbc825b0ebf9c533f1a7ec8b.svg";
export { ForwardRef as ReactComponent };